import { gsap } from 'gsap'
import { TextPlugin } from 'gsap/TextPlugin'

gsap.registerPlugin(TextPlugin)

export default () => ({
	init() {
		const introTexts = Array.from(document.querySelectorAll('[data-intro-text]'))

		const tl = gsap.timeline({
			onComplete: () => {
				setTimeout(() => {
					if (this.$store && this.$store.site && typeof this.$store.site.setIntroSeen === 'function') {
						this.$store.site.setIntroSeen()
					}
				}, 1000)
			},
		})
		introTexts.forEach(el => {
			const text = el.getAttribute('data-intro-text') || ''
			el.textContent = ''
			tl.to(el, {
				duration: Math.max(text.length * 0.025, 0.1),
				text: { value: text },
				ease: 'none',
				delay: 0,
			})
		})
	},
})
